import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "employee-cell" }
const _hoisted_2 = { class: "employee-name" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-square-plus" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "expand-icon"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "edit-row"
}
const _hoisted_8 = ["colspan"]
const _hoisted_9 = { class: "table table-responsive-md border border-gray" }
const _hoisted_10 = { class: "bg-table-header table-header" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Task ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Agency ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Branch ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Patient Name ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Scheduled Date ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", null, "Scheduled Time", -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", null, "Hours", -1 /* HOISTED */)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", null, "Status", -1 /* HOISTED */)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", null, "Action", -1 /* HOISTED */)
const _hoisted_20 = {
  key: 0,
  class: "table-empty fw-normal"
}
const _hoisted_21 = ["colspan"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", null, "No Tasks Found.", -1 /* HOISTED */)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "emp_summary_evv" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "btn-group table-btn-group"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-xs px-1 py-0 btn-outline-primary dropdown-toggle",
  "data-bs-toggle": "dropdown"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h" })
], -1 /* HOISTED */)
const _hoisted_28 = { class: "dropdown-menu dropdown-transform-right" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortableTh = _resolveComponent("SortableTh")!
  const _component_ProductPill = _resolveComponent("ProductPill")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      id: "summary_row",
      class: _normalizeClass(`border-line ${_ctx.summary.id === _ctx.viewScheduleId ? 'edit-row td-border' : ''}`)
    }, [
      _createElementVNode("td", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.summary.name), 1 /* TEXT */),
          (_ctx.summary.id !== _ctx.viewScheduleId)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "expand-icon",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleViewSchedule(_ctx.summary)))
              }, _hoisted_4))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createElementVNode("i", {
                  class: "fa-regular fa-square-minus",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCloseViewSchedule()))
                })
              ]))
        ])
      ]),
      (_ctx.summary.userSummaryData.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.summary.userSummaryData, (countData) => {
            return (_openBlock(), _createElementBlock("td", null, [
              (countData.TotalVisits || countData.TotalHours)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(`V:${countData.TotalVisits}/ H:${countData.TotalHours}`), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(7, (i) => {
            return _createElementVNode("td")
          }), 64 /* STABLE_FRAGMENT */)),
      _createElementVNode("td", null, _toDisplayString(`V: ${_ctx.summary.totalVisits} / H: ${_ctx.summary.totalHours}`), 1 /* TEXT */)
    ], 2 /* CLASS */),
    (_ctx.isViewScheduleRequested)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-3 edit"
          }, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_10, [
                  _createElementVNode("th", null, [
                    _createVNode(_component_SortableTh, {
                      "sort-by": _ctx.sortBy,
                      onSortByUpdated: _ctx.sortByUpdated,
                      "sort-order": _ctx.sortOrder,
                      onSortOrderUpdated: _ctx.sortOrderUpdated,
                      "sort-string": "taskName"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                  ]),
                  _createElementVNode("th", null, [
                    _createVNode(_component_SortableTh, {
                      "sort-by": _ctx.sortBy,
                      onSortByUpdated: _ctx.sortByUpdated,
                      "sort-order": _ctx.sortOrder,
                      onSortOrderUpdated: _ctx.sortOrderUpdated,
                      "sort-string": "agencyName"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                  ]),
                  _createElementVNode("th", null, [
                    _createVNode(_component_SortableTh, {
                      "sort-by": _ctx.sortBy,
                      onSortByUpdated: _ctx.sortByUpdated,
                      "sort-order": _ctx.sortOrder,
                      onSortOrderUpdated: _ctx.sortOrderUpdated,
                      "sort-string": "branchName"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                  ]),
                  _createElementVNode("th", null, [
                    _createVNode(_component_SortableTh, {
                      "sort-by": _ctx.sortBy,
                      onSortByUpdated: _ctx.sortByUpdated,
                      "sort-order": _ctx.sortOrder,
                      onSortOrderUpdated: _ctx.sortOrderUpdated,
                      "sort-string": "patientName"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                  ]),
                  _createElementVNode("th", null, [
                    _createVNode(_component_SortableTh, {
                      "sort-by": _ctx.sortBy,
                      onSortByUpdated: _ctx.sortByUpdated,
                      "sort-order": _ctx.sortOrder,
                      onSortOrderUpdated: _ctx.sortOrderUpdated,
                      "sort-string": "startDate"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                  ]),
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18,
                  _withDirectives(_createElementVNode("th", null, "EVV", 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.schedulesIncludesHHOrHCVisit]
                  ]),
                  _hoisted_19
                ])
              ]),
              _createElementVNode("tbody", null, [
                (!_ctx.sortedSchedules.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                      _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_23, 8 /* PROPS */, _hoisted_21)
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.sortedSchedules, (schedule) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "border-line fw-normal",
                        key: schedule.Id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(schedule.TaskName), 1 /* TEXT */),
                        _createElementVNode("td", null, [
                          _createVNode(_component_ProductPill, {
                            productId: schedule.Application === 256 ? -3 : schedule.Application
                          }, null, 8 /* PROPS */, ["productId"]),
                          _createTextVNode(" " + _toDisplayString(schedule.AgencyName), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(schedule.BranchName), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getPatientName(schedule)), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(schedule.StartDate, "MM/DD/YYYY")), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getTime(schedule)), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getHour(schedule)), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(schedule.Status), 1 /* TEXT */),
                        _withDirectives(_createElementVNode("td", _hoisted_24, [
                          _createElementVNode("span", {
                            onClick: ($event: any) => (_ctx.openEvvHouse(schedule)),
                            style: {"cursor":"pointer"}
                          }, [
                            _createElementVNode("a", {
                              class: _normalizeClass(_ctx.getEvvButtonClass(schedule))
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(_ctx.getEvvIconClass(schedule))
                              }, null, 2 /* CLASS */)
                            ], 2 /* CLASS */)
                          ], 8 /* PROPS */, _hoisted_25)
                        ], 512 /* NEED_PATCH */), [
                          [_vShow, _ctx.schedulesIncludesHHOrHCVisit]
                        ]),
                        _createElementVNode("td", null, [
                          (_ctx.hasAnyAction(schedule))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                _hoisted_27,
                                _createElementVNode("div", _hoisted_28, [
                                  (_ctx.canReassign(schedule))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        class: "dropdown-item",
                                        href: "javascript:void(0);",
                                        onClick: ($event: any) => (_ctx.scheduledVisit(schedule))
                                      }, " Reassign ", 8 /* PROPS */, _hoisted_29))
                                    : _createCommentVNode("v-if", true),
                                  (_ctx.canViewDetails(schedule))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        class: "dropdown-item",
                                        href: "javascript:void(0);",
                                        onClick: ($event: any) => (_ctx.showVisitDetails(schedule))
                                      }, " Details ", 8 /* PROPS */, _hoisted_30))
                                    : _createCommentVNode("v-if", true),
                                  (_ctx.canViewProfile(schedule))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 2,
                                        class: "dropdown-item",
                                        href: "javascript:void(0);",
                                        onClick: ($event: any) => (_ctx.openProfile(schedule))
                                      }, " Profile ", 8 /* PROPS */, _hoisted_31))
                                    : _createCommentVNode("v-if", true),
                                  (_ctx.canGoToPatientChart(schedule))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 3,
                                        class: "dropdown-item",
                                        href: "javascript:void(0);",
                                        onClick: ($event: any) => (_ctx.handlePatientNameClick(schedule))
                                      }, " Patient Chart ", 8 /* PROPS */, _hoisted_32))
                                    : _createCommentVNode("v-if", true),
                                  (_ctx.canDelete(schedule))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 4,
                                        class: "dropdown-item",
                                        href: "javascript:void(0);",
                                        onClick: ($event: any) => (_ctx.deleteTask(schedule))
                                      }, " Delete ", 8 /* PROPS */, _hoisted_33))
                                    : _createCommentVNode("v-if", true)
                                ])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ], 8 /* PROPS */, _hoisted_8)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}